// extracted by mini-css-extract-plugin
export default {"appLoader":"App_appLoader__J69-t"};